import React, { useState } from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';

import About from './components/About';
import Portfolio from './components/Portfolio';
import Contact from './components/Contact';
import Navbar from './components/Navbar';
import Gallery from './components/Gallery';
import Artists from './components/Artists';
import Simone from './components/Simone';
import Didi from './components/Didi';

import Michelangelo from './components/Magazine/Michelangelo';
import Maddalena from './components/Magazine/Maddalena';
import Gmaro from './components/Magazine/Gmaro';
import MeganTMRW from './components/Magazine/MeganUno';

import MeganNextGen from './components/Magazine/MeganNextGen';
import TrentatreRia from './components/Magazine/MeganDue';
import Mob from './components/Magazine/Mob';
import Offtown from './components/Magazine/Offtown';
import Trentatre from './components/Magazine/Trentatre';
import Virginia from './components/Magazine/Virginia';
import Mfwsemptember from './components/MFW/Mfwseptember';
import MfwHome from './components/MFW/MfwHome';
import Mfw2025 from './components/MFW/Mfw2025';

import Mfwfebruary from './components/MFW/Mfwfebruary';
import Press from './components/Press';


import Footer from './components/Footer';
import Magazine from './components/Magazine';

import Campaign from './components/Campaign';
import Talent from './components/Talent';
import ScrollToTop from './components/ScrollToTop'; // Importa ScrollToTop

import Hero from './components/Hero'
import Redcarpet from './components/RedCarpet/Redcarpet';
function App() {
  const [isDropdownOpen, setDropdownOpen] = useState(false);
  
  

  // Funzione per gestire l'apertura e la chiusura del dropdown
  const handleDropdownToggle = (isOpen) => {
    setDropdownOpen(isOpen);
    // Aggiorna la visibilità della sezione Contact
  };

  // Aggiungi un listener per il ridimensionamento della finestra
  return (
    <Router>
      <ScrollToTop />
      <Navbar onDropdownToggle={handleDropdownToggle} />
      <div className="App">
        <main>
          <Routes>
            <Route
              path="/"
              element={
                <>
                  <Hero isDropdownOpen={isDropdownOpen} />
                  <About />
                  <Portfolio />
                  <Gallery />
                  <Footer />
                </>
              }
            />
            <Route
              path="/contact"
              element={ <Contact /> }
            />
            {/* Aggiungi altre rotte qui se necessario */}
            <Route
              path="/Artists"
              element={<Artists />}
            />
             {/* Pagina dettaglio Simone */}
            <Route 
            path="/artists/Simone" 
            element={<Simone />} />
            {/* Pagina dettaglio Didi */}
            <Route 
            path="/artists/Didi" 
            element={<Didi />} />
            <Route
              path="/magazine"
              element={<Magazine />}
            />
            <Route
              path="/michelangelo"
              element={<Michelangelo />} // Aggiungi la route per Michelangelo
            />
             <Route
              path="/maddalena"
              element={<Maddalena />} // Aggiungi la route per Maddalena
            />
            <Route
              path="/gmaro"
              element={<Gmaro />} // Aggiungi la route per GMARO
            />
            <Route
              path="/MeganNextGen"
              element={<MeganNextGen />} // Aggiungi la route per MeganNextGen
            />
             <Route
              path="/MeganTMRW"
              element={<MeganTMRW />} // Aggiungi la route per GMARO
            />
             <Route
              path="/TrentatreRia"
              element={<TrentatreRia />} // Aggiungi la route per GMARO
            />
            <Route
              path="/Mob"
              element={<Mob />} // Aggiungi la route per GMARO
            />
            <Route
              path="/Offtown"
              element={<Offtown />} // Aggiungi la route per GMARO
            />
            <Route
              path="/Trentatre"
              element={<Trentatre />} // Aggiungi la route per GMARO
            />
            <Route
              path="/Virginia"
              element={<Virginia />} // Aggiungi la route per GMARO
            />
            <Route
              path="/Mfwseptember"
              element={<Mfwsemptember />} // Aggiungi la route per GMARO
            />
            <Route
              path="/Mfw2025"
              element={<Mfw2025 />} // Aggiungi la route per GMARO
            />
            <Route
              path="/Mfwfebruary"
              element={<Mfwfebruary />} // Aggiungi la route per GMARO
            />  
            <Route
              path="/Redcarpet"
              element={<Redcarpet />} // Aggiungi la route per GMARO
            />  
            <Route
              path="/campaign"
              element={<Campaign />}
            />
             <Route
              path="/talent"
              element={<Talent />}
            />
             <Route
              path="/MfwHome"
              element={ <MfwHome /> }
            />
             <Route
              path="/Press"
              element={<Press />} 
            /> 
            

          </Routes>
        </main>
      </div>
    </Router>
  );
}

export default App;
